import React from 'react';
import { Link } from 'react-router-dom';

export function NotFound(): React.ReactElement {
  return (
    <div className="text-center flex flex-col gap-3 py-16">
      <h1 className="text-4xl font-bold">404</h1>
      <p style={{ color: 'var(--text-secondary)' }}>That page doesn&apos;t exist.</p>
      <Link to="/" className="btn-primary self-center">
        Back home
      </Link>
    </div>
  );
}
